// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3077) return "static/chunks/3077-350225272e3e96f5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"542":"a35a4df012679d1f","1794":"3660dd1eee89487d","2110":"0319e8eb5a6669ee","4960":"41c0b37994e76d18","6647":"eb3a34c5ffbd89e8"}[chunkId] + ".js";
};